import Box from '@mui/material/Box';
import { DisplaySlot } from 'generated/graphql';
import { Colors } from 'styles/index';

const ICON_WIDTH = 72;
const ICON_HEIGHT = 44;
const MONITOR_GAP = 3;

export const DisplayArrangementIcon = ({
  displaySlots = [],
}: {
  displaySlots?: ReadonlyArray<Partial<DisplaySlot>>;
}) => {
  const displays = displaySlots.filter(
    (d) => d.left != null && d.top != null && d.width != null && d.height != null
  );

  if (displays.length === 0) {
    return null;
  }

  const minLeft = Math.min(...displays.map((d) => d.left ?? 0));
  const minTop = Math.min(...displays.map((d) => d.top ?? 0));
  const maxRight = Math.max(...displays.map((d) => (d.left ?? 0) + (d.width ?? 0)));
  const maxBottom = Math.max(...displays.map((d) => (d.top ?? 0) + (d.height ?? 0)));

  const layoutWidth = maxRight - minLeft;
  const layoutHeight = maxBottom - minTop;

  const scale = Math.min(
    (ICON_WIDTH - MONITOR_GAP * 2) / layoutWidth,
    (ICON_HEIGHT - MONITOR_GAP * 2) / layoutHeight
  );

  const scaledWidth = layoutWidth * scale;
  const scaledHeight = layoutHeight * scale;

  const offsetX = (ICON_WIDTH - scaledWidth) / 2;
  const offsetY = (ICON_HEIGHT - scaledHeight) / 2;

  return (
    <Box
      sx={{
        width: ICON_WIDTH,
        height: ICON_HEIGHT,
        mr: 2,
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {displays.map((display, index) => (
        <Box
          data-testid={`display-${index}`}
          key={display.index ?? index}
          sx={{
            position: 'absolute',
            left: offsetX + ((display.left ?? 0) - minLeft) * scale,
            top: offsetY + ((display.top ?? 0) - minTop) * scale,
            width: Math.max((display.width ?? 0) * scale - MONITOR_GAP, 10),
            height: Math.max((display.height ?? 0) * scale - MONITOR_GAP, 10),
            borderRadius: '2px',
            border: `1px solid ${Colors.gray7}`,
            backgroundColor: Colors.gray3,
          }}
        />
      ))}
    </Box>
  );
};
